export default __webpack_public_path__ + "static/media/icons8-touchpad-100.950cb55b.svg";